export const login = (id: number) => {
  window.location.href = `${process.env.REACT_APP_FRONTEND_PROTOCOL}://${process.env.REACT_APP_FRONTEND_CLIENT_DOMAIN}/admin-login-to-client?userId=${id}`;
};
